import { createSimpleFilterConfig } from '../factories/create-simple-filter-config';
import { BOOLEAN_EXCLUDE_PREFIX } from '../helpers/filter-none';
import { FILTER_COLOR } from './filter-colors';

const ENROLLED_FIELD = 'is_enrolled';

export const leadEnrollmentStatusFilterConfig = createSimpleFilterConfig({
  facetName: 'enrollment_status',
  color: FILTER_COLOR.green,
  withNoneOption: false,
  booleanValues: true,
  options: [
    { label: 'Enrolled', value: ENROLLED_FIELD },
    {
      label: 'Not enrolled',
      value: `${BOOLEAN_EXCLUDE_PREFIX}${ENROLLED_FIELD}`,
    },
  ],
});
